<template>
    <select class="fieldselect"
            v-model="item.value"
            multiple
            size="5">
        <option
            v-for="postType in postTypes"
            :key="postType.value"
            :value="postType.value"
            v-text="postType.label">
        </option>
    </select>
</template>

<script>
import {get} from 'lodash'
import postApi from '../../../api/PostApi'
import {Listeners} from "../../../constants/listeners";

export default {
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    data: () => ({
        postTypes: [],
    }),
    methods: {
        submitFormFilter() {
            this.$emitter.emit(Listeners.KS_FILTER_SUBMIT_FORM);
        },
        async loadPostTypes() {
            const data = await postApi.getPostTypes()
            if(!data) {
                return;
            }

            this.postTypes = data;
        },
        /**
         * Парсит строку в массив.
         * При обновлении страницы в value может попасть строка со значениями через запятую.
         */
        parsePresetValue() {
            let value = this.item.value;
            if(Array.isArray(value)) {
                return;
            }

            if(typeof value !== 'string') {
                this.item.value = [];
                return;
            }

            this.item.value = value.split(',');
        },
        setDefaultValue() {
            let value = Array.isArray(this.item.value) ? this.item.value : [];

            const defaultPostType = get(this.postTypes, '0');
            if(!defaultPostType) {
                return;
            }

            value = value.length > 0 ? value : [defaultPostType.value];

            this.item.value = value;
        },
        async init() {
            this.parsePresetValue();
            await this.loadPostTypes();
            this.setDefaultValue();
        }
    },
    created() {
        this.init();
    },
}
</script>
